import Helpers from '../modules/Helpers'

class NRequired {
    constructor(group) {
        this.group = group

        this.requiredCount = parseInt(group.getAttribute("data-required-count") || 0)
        this.inputs = Array.from(group.getElementsByTagName('input'))

        if (this.inputs[0].setCustomValidity === undefined) {
            // can't use this here, the browser doesn't support it
            return
        }

        this.setValidity()
        this.setListener()
    }

    populatedCount() {
        return this.inputs.filter(i => i.value.length > 0).length
    }

    setValidity() {
        // reset
        this.clearValidity()
        // if set count less than required specify invalidity
        if (this.populatedCount() < this.requiredCount) {
            this.inputs.forEach((input) => {
                if (input.value.length == 0) {
                    input.setCustomValidity('At least ' + this.requiredCount + ' must be provided')
                }
            })
        }
    }

    clearValidity() {
        this.inputs.forEach((input) => {
            input.setCustomValidity('')
        })
    }

    setListener() {
        let self = this

        this.inputs.forEach((input) => {
            new Helpers(input).eventListener((e) => {
                self.setValidity()
            }, 'change')
        })
    }
}

export default NRequired